var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showAd)?_c('af-overlay',{attrs:{"dark":true}},[_c('a',{attrs:{"href":_vm.popupAdUrl,"alt":"Subscribe"}},[_c('img',{staticClass:"popup-ad",attrs:{"src":_vm.popupAd}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }